import React from "react";
class MapRockyMountainNP extends React.Component {
  render() {
    return (
      <React.Fragment>
        <section id="map-rocky-mountain-national-park" className="about-us gray-light-bg">
          <iframe
            src="https://maps.google.com/maps?saddr=Estes+Park,+CO&daddr=Beaver+Meadows+Visitor+Center,+CO+to:Bear+Lake,+Rocky+Mountain+National+Park,+CO+to:Dream+Lake,+CO+to:Alpine+Visitor+Center,+Trail+Ridge+Road,+CO+to:Moraine+Park,+CO+to:Kawuneeche+Valley,+CO&output=embed"
            width="100%"
            height="420"
            title="Rocky Mountain National Park route map">
          </iframe>
        </section>
      </React.Fragment>
    );
  }
}
export default MapRockyMountainNP;
